// extracted by mini-css-extract-plugin
export default {"card":"Main_card__iKgbV","h1":"Main_h1__0LZGp","p":"Main_p__VmDaO","img":"Main_img__j55AQ","a":"Main_a__GZSbn","button1":"Main_button1__Hg-5b","button2":"Main_button2__TltJZ"};